<template>

    <!-- PAGE CONTENT
    ============================================= -->	
    <div id="page" class="page">


       <header_menu></header_menu>

        <!-- PRESENTATION-->	
        <section id="hero-1" class="bg-fixed hero-section division">
            <div class="container">	
                <div class="row">


                    <!-- HERO TEXT -->
                    <div class="col-md-12 col-lg-12">
                        <div class="hero-txt white-color">	

                            <!-- Title -->
                            <h2 class="h2-lg " data-animation="fadeInUp" data-animation-delay="300">Erreur</h2>

                            <h2 class="h2-lg hkh " data-animation="fadeInUp" data-animation-delay="300"> 404</h2>
                           

                            <!-- Title -->
                            <h2 class="h2-lg " data-animation="fadeInUp" data-animation-delay="300"> Cette page semble indisponible</h2>

                           

                    
                                
                        </div>	 <!-- End row -->   
                    </div>	 <!-- End container --> 

                    <div class="col-lg-10 offset-lg-1">
                        <div class="press-txt text-center m-top-20">	

                            <!-- Text -->
                            <p></p>
                            <!-- Button -->						
                            <RouterLink to="./" class="btn btn-lightorange ">Retour à l'accueil</RouterLink>

                        </div>
						</div>

                    


                </div>	   <!-- End row --> 
            </div>      <!-- End container --> 
        </section>	
        <!-- END PRESENTATION -->    

        
       
        <footer_menu></footer_menu>    

        <!-- <RouterView/> -->

    </div>

</template>

<script>
    import header_menu  from '../components/header_menu.vue';
    import footer_menu  from '../components/footer_menu.vue';

    

    export default{
        name:'home_view',
        components:{
       
        'header_menu' :header_menu,
        'footer_menu' :footer_menu,
        },      
           
    } 

</script>


<style scoped>
.error{
    font-size: 2rem !important;
}
.hkh{
    font-size: 12rem !important;  
}

.btn-lightorange{
    color: #fff;
    background-color: #ff9e00;
    border-color: #f3a72e;
}
.h2-lg{
    text-align: center;
}

h2.h2-lg { font-size: 2.8rem; }   /* 60px */


#hero-1 .hero-txt {
    margin-top: 50px;
}

button {
 position: relative;
 display: inline-block;
 cursor: pointer;
 outline: none;
 border: 0;
 vertical-align: middle;
 text-decoration: none;
 background: transparent;
 padding: 0;
 font-size: inherit;
 font-family: inherit;
}

button.learn-more {
 width: 17rem;
 height: auto;
}

button.learn-more .circle {
 transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
 position: relative;
 display: block;
 margin: 0;
 width: 3rem;
 height: 3rem;
 background: #281d67;
 border-radius: 1.625rem;
}

button.learn-more .circle .icon {
 transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
 position: absolute;
 top: 0;
 bottom: 0;
 margin: auto;
 background: #fff;
}

button.learn-more .circle .icon.arrow {
 transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
 left: 0.625rem;
 width: 1.125rem;
 height: 0.125rem;
 background: none;
}

button.learn-more .circle .icon.arrow::before {
 position: absolute;
 content: "";
 top: -0.29rem;
 right: 0.0625rem;
 width: 0.625rem;
 height: 0.625rem;
 border-top: 0.125rem solid #fff;
 border-right: 0.125rem solid #fff;
 transform: rotate(45deg);
}

button.learn-more .button-text {
 transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
 position: absolute;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 padding: 0.75rem 0;
 margin: 0 0 0 1.85rem;
 color: #fff;
 font-weight: 600;
 line-height: 1.6;
 text-align: center;
 text-transform: uppercase;
 font-style: normal !important;
}

button:hover .circle {
 width: 100%;
}

button:hover .circle .icon.arrow {
 background: #fff;
 transform: translate(1rem, 0);
}

button:hover .button-text {
 color: #fff;
}
.precent_rem{
    color: #ff9e00;
    font-size: 4rem;
}


/* cards privileges */
.box16{text-align:left;color:#fff;position:relative}
.box16 .box-content,.box16:after{width:100%;position:absolute;left:0}
.box16:after{content:"";height:100%;background:linear-gradient(to bottom,rgba(0,0,0,0) 0,rgba(0,0,0,.08) 69%,rgba(0,0,0,.76) 100%);top:0;transition:all .5s ease 0s}
.box16 .post,.box16 .title{transform:translateY(145px);transition:all .4s cubic-bezier(.13,.62,.81,.91) 0s}
.box16:hover:after{background:linear-gradient(to bottom,rgba(0,0,0,.01) 0,rgba(0,0,0,.09) 11%,rgba(0,0,0,.12) 13%,rgba(0,0,0,.19) 20%,rgba(0,0,0,.29) 28%,rgba(0,0,0,.29) 29%,rgba(0,0,0,.42) 38%,rgba(0,0,0,.46) 43%,rgba(0,0,0,.53) 47%,rgba(0,0,0,.75) 69%,rgba(0,0,0,.87) 84%,rgba(0,0,0,.98) 99%,rgba(0,0,0,.94) 100%);}
.box16 img{width:100%;height:auto}
.box16 .box-content{padding:20px;margin-bottom:30px;bottom:0;z-index:1}
.box16 .title{font-size:22px;font-weight:700;margin:0 0 10px}
.box16 .post{display:block;padding:8px 0;font-size:15px}
.box16 .social li a,.box17 .icon li a{border-radius:50%;font-size:20px;color:#fff}
.box16:hover .post,.box16:hover .title{transform:translateY(0)}
.box16 .social{list-style:none;padding:0 0 5px;margin:40px 0 25px;opacity:0;position:relative;transform:perspective(500px) rotateX(-90deg) rotateY(0) rotateZ(0);transition:all .6s cubic-bezier(0,0,.58,1) 0s}
.box16:hover .social{opacity:1;transform:perspective(500px) rotateX(0) rotateY(0) rotateZ(0)}
.box16 .social:before{content:"";width:50px;height:0px;background:#fff;margin:0 auto;position:absolute;top:-23px;left:0;right:0; }
.box16 .social li{display:inline-block}
.box16 .social li a{display:block;width:40px;height:40px;line-height:40px;background:#261b64;margin-right:10px;transition:all .3s ease 0s}
.box17 .icon li,.box17 .icon li a{display:inline-block}
.box16 .social li a:hover{background:#ff9e00}
.box16 .social li:last-child a{margin-right:0}
@media only screen and (max-width:990px){.box16{margin-bottom:30px}
}
/* fin card privileges */
</style>